import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  makeStyles,
  createStyles,
  Theme,
} from '@material-ui/core';
import { DropdownFieldProps } from './types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      width: '100%',
      '& .MuiOutlinedInput-root': {
        backgroundColor: theme.palette.background.paper,
      },
    },
  }),
);

export const DropdownField: React.FC<DropdownFieldProps> = ({
  label = 'Select option',
  value = '',
  onChange,
  options = [],
  placeholder = 'Select...',
}) => {
  const classes = useStyles();

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    onChange?.(event.target.value as string);
  };

  return (
    <FormControl variant="outlined" size="small" className={classes.formControl}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        onChange={handleChange}
        label={label}
        displayEmpty
      >
        <MenuItem value="">
          
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
